module.exports = __webpack_public_path__ + "img/vertical_4_3_5012.ee7b9e1b.png";